import { render, staticRenderFns } from "./CustomizeMetalM.vue?vue&type=template&id=587c6d39&scoped=true"
import script from "./CustomizeMetalM.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalM.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalM.vue?vue&type=style&index=0&id=587c6d39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c6d39",
  null
  
)

export default component.exports